<template>
<div>
    <a type="button" class="kt-link text-primary"  @click="goToRoute">{{title}}</a>
</div>
</template>
<script>

import Vue from 'vue'
import router from '@/router'


export default Vue.extend({
    props: {
        id: {
            required: true,
        },
        route_name: {
            required: true,
        },
        title: {
            required: true,
        }
    },
    methods: {
        goToRoute() {
            router.push({name: this.route_name, params: {hashid: this.id}})
        }
    }
})
</script>